<div class="auth-wrapper d-flex no-block justify-content-center align-items-center"
     style="background: #f6f9fa;"
     (keydown.enter)="check()">
  <div>
    <div class="auth-box">
      <div id="loginformBox" [ngClass]="{'d-none': recoverform}">
        <div class="logo">
                    <span class="db"><img src="assets/images/logo-dark-blue.svg" alt="logo"
                                          style="max-height: 200px; max-width:100%;" /></span>
          <h5 class="font-medium m-b-20">{{ claim | translate }}</h5>
        </div>
        <div *ngIf="msg" class="alert alert-danger">{{ msg }}</div>
        <!-- Form -->
        <div class="row">
          <div class="col-12">
            <form class="form-horizontal m-t-20" [formGroup]="loginform" id="loginform">
              <div class="input-group  mb-3">
                <div class="input-group-text" id="btnGroupAddon"><i class="ti-user"></i></div>
                <input type="text" class="form-control form-control-lg" formControlName="email"
                       [placeholder]="'login.username' | translate"
                       [attr.aria-label]="'login.username' | translate"
                       aria-describedby="basic-addon1" >
              </div>
              <div class="input-group  mb-3">
                <div class="input-group-text" id="btnGroupAddon"><i class="ti-pencil"></i></div>
                <input type="password" class="form-control form-control-lg" formControlName="password"
                       [placeholder]="'login.password' | translate"
                       [attr.aria-label]="'login.password' | translate"
                       aria-describedby="basic-addon1">
              </div>
              <div *ngIf="adminMode" class="input-group  mb-3">
                <div class="input-group-text" id="btnGroupAddon"><i class="ti-user"></i></div>
                <input type="text" class="form-control form-control-lg" formControlName="logas"
                       [placeholder]="'login.loginAs' | translate"
                       [attr.aria-label]="'login.loginAs' | translate"
                       aria-describedby="basic-addon1" >
              </div>

              <div class="form-group text-center">
                <div class="col-xs-12 p-b-20">
                  <button class="btn btn-block btn-lg btn-info" type="button"
                          (click)="check()">
                    {{ 'login.button' | translate }}
                  </button>
                </div>
              </div>
              <div class="forgot-password-link" align="center">
                <a href="#" (click)="showRecoverForm($event)">{{ 'login.forgotPassword' | translate }}</a>
              </div>

              <!-- Google Sign-In. Kept in the DOM (not *ngIf) because Google renders its button
                   into #googleButton, which has to exist first; `hidden` until that succeeds, so
                   nothing shows if sign-in is unconfigured or GIS fails to load and password login
                   is never blocked by it. -->
              <div class="google-signin" [hidden]="!googleReady">
                <div class="google-signin__divider">
                  <span>{{ 'login.orDivider' | translate }}</span>
                </div>
                <div #googleButton class="google-signin__button"></div>
              </div>
              <!--                            <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 m-t-10 text-center">
                      <div class="social">
                          <a href="javascript:void(0)" class="btn btn-facebook" data-toggle="tooltip" title=""
                              data-original-title="Login with Facebook"> <i aria-hidden="true" class="fab fa-facebook"></i>
                          </a>
                          <a href="javascript:void(0)" class="btn btn-googleplus ml-2" data-toggle="tooltip" title=""
                              data-original-title="Login with Google"> <i aria-hidden="true" class="fab fa-google-plus"></i>
                          </a>
                      </div>
                  </div>
              </div> -->
              <!--                            <div class="form-group m-b-0 m-t-10">- ->
                  <div class="col-sm-12 text-center">- ->
                      Don't have an account? <a href="#/authentication/signup" class="text-info m-l-5"><b>Sign
                      Up</b></a>
                  </div>
              </div>-->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<footer class="footer">
  <app-custom-footer></app-custom-footer>
</footer>

<!--<notifier-container></notifier-container>-->
